<div>
    <div class="card">
        <div class="card-header">
           Reporte por empresas
        </div>
    </div>

    <div class="card">
      <div class="card-header">
        <p><strong>Seleccione una empresa:</strong></p>
      </div>
      <div class="card-body">
        <div class="container">

            <div class="row" style="background-color: rgba#9b9a9a;" >
              <p>2. Seleccione una empresa: - </p>
              <div class="form-group">
                <select class="form-control" id="exampleFormControlSelect1" [(ngModel)]="empresaSeleccionada"  >
                    <option selected="true" value="">Seleccione una opcion</option>
                    <option *ngFor="let item of arraydeempresas">{{item}}</option>
                </select>
              </div>
            </div>
            <hr>
            
        </div>
        <div *ngIf="alertaActiva">
            <p>
                <ngb-alert [type]="tipodeAlerta" (close)="closeAlert()">{{ mensajeAlerta }}</ngb-alert>
            </p>
        </div>
        
        <div>
          <hr>
          <button class="btn btn-success btn-block" (click)="cargareporte()"style="float: right; margin-right: 6px;">Generar reporte</button>
        </div>
      </div>
    </div>



      <div >
        <!-- <table datatable [dtOptions]="dtOptions"[dtTrigger]="dtTrigger" class="row-border hover" id="tabla"   >
          <thead>
            <tr>
              <th>Acciones</th>
              <th>Ticket</th>
              <th>Empresa</th>
              <th>Fecha inicio</th>
              <th>Fecha fin</th>
              <th>Solicitante</th>
              <th>Trabajadores</th>
              <th>Descripción PTW</th>
              <th>Cuenca</th>
              <th>Locacion</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
             
      
            <tr *ngFor="let item of arraydeposts">
              <td><button type="button" class="btn btn-primary btn-sm" (click)="detalles(item)"> Acciones</button></td>
                <td><small>{{item.data().ticket}}</small></td>
                <td><small>{{item.data().empresa}}</small></td>
                <td><small>{{item.data().fechainicio}}</small></td>
                <td><small>{{item.data().fechafinal}}</small></td>
                <td><small>{{item.data().solicitante}}</small></td>
                <td>
                    <table style=" border: 1px solid black; border-collapse: collapse;">
                        <tr  *ngFor="let empleado of item.data().arrayDeEmpleados"> 
                            <td style=" border: 1px solid black; border-collapse: collapse;"><small>Nombre: {{empleado.nombre}}</small></td>
                            <td style=" border: 1px solid black; border-collapse: collapse;"><small>ID: {{empleado.id}}</small></td>
                            <td style=" border: 1px solid black; border-collapse: collapse;"><small>ARL: {{empleado.arl}}</small></td>
                        </tr>
                    </table>
                </td> 
                <td><small>{{item.data().descripcionPTW}}</small></td> 
                <td><small>{{item.data().cuenca}}</small></td> 
                <td><small>{{item.data().pozoSeleccionado}}</small></td>  
                <td><small>{{item.data().status}}</small></td>   
            </tr>
            
          </tbody>
        </table>  -->
      </div>



</div>
